import updateProgress from './update-progress';

const updateProgressWrapper = (node, resp) => {
  // Get new progress bar markup
  const newProgressElem = new DOMParser()
    .parseFromString(resp, 'text/html')
    .querySelector('[data-pagination-progress]');

  // Update progress bar width
  updateProgress(newProgressElem);

  // Get progress wrapper and insert new progress bar
  const progressWrapper = node.querySelector('[data-progress-wrapper]');
  progressWrapper.innerHTML = '';
  progressWrapper.appendChild(newProgressElem);
};

export default updateProgressWrapper;
